/**
 *
 * Tracking
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import AutoComplete from "components/AutoComplete"
import Sorter from "components/Sorter"
import ActionPlanCard from "components/ActionPlanCard"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import ModalCustom from "components/ModalCustom"
import {
  Avatar,
  Button,
  Empty,
  List,
  TreeSelect,
  Spin,
  Pagination,
  Dropdown,
  Menu,
  Tooltip,
  Row,
  Col
} from "antd"
import SelectHR from "components/Select"
import WidgetResumeActionPlans from "components/WidgetResumeActionPlans"
import ModalImportActionPlans from "../../../components/ModalImportActionPlans"
import emptyStateActionPlans from "images/empty-state-action-plans.svg"
import arrowLeftBlue from "images/arrow-left-blue.svg"
import alertSvg from "images/alert.svg"
import { saveActionPlanApi } from "services/actionPlans"
import { isEqual } from "lodash"
import {
  filtersWatcher,
  getPlansWatcher,
  getTemplate,
  getTemplateTask,
  getSurveys,
} from "./actions"
import saga from "./saga"
import reducer from "./reducer"
import {
  makeSelectFilters,
  makeSelectIsLoadingFilters,
  makeSelectLoadingPlans,
  makeSelectPlans,
  makeSelectSidebarAmbassadors,
  makeSelectSidebarDivisions,
  makeSelectCountActionPlansDivisions,
  makeSelectResume,
  makeSelectSurveys,
} from "./selectors"
import "./index.less"
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import { uuid, validate } from "../../../utils/functions"
import { isAdmin, isAmbassadorActive, isAmbassadorOrLeaderActive, LOCAL_AMBASSADOR_ID, LOCAL_PDA_IA_ENABLED, LOCAL_AI_LIMIT_REACHED, LOCAL_USER_ROLES } from "../../../utils/storage"
import { loadTexts, sanitize, getLanguage } from "../../../utils/i18n"
import { buttonAction_btns } from "../../../components/Snowplow/config2"
import IconoVaritaMagica from "components/ModalActionPlanCreate/IconoVaritaMagica"
import DashboardSuggestionsIA from "components/DashboardSuggestionsIA"
import { getDivisionsForAmbassadorDashboard } from "services/actionPlans"
import { RoleSelector } from "../../RoleSelector"
import { ROLE_AMBASSADOR, ROLE_COMPANY_ADMIN, ROLE_COMPANY_SUPER_ADMIN, ROLE_LEADER, ROLES_ADMIN } from "../../../utils/constants"

const { TreeNode } = TreeSelect

/* eslint-disable react/prefer-stateless-function */
export class Tracking extends React.Component {

  state = {
    isIframe: false,
  }
  
  intl = loadTexts("tracking")
  state = {
    paginationCurrentPage: 1,
    paginationPageSize: 15,
    modalActionPlanCreate: false,
    selectedSearch: "",
    selectedMedition: null,
    selectedDimension: null,
    selectedStatus: null,
    selectedDivision: null,
    selectedOrder: null,
    isFilter: false,
    rows: [],
    secondStepModal: false,
    modalActionPlanEditId: null,
    can_create_action_plan: false,
    modalArchivePlan: false,
    modalArchiveLoading: false,
    currentPlan: {},
    isModalVisibleImportActionPlans: false,
    modalActionPlanCreateIa: false,
    modalActionPlanCreateNormal: false,
    resultDimensionsIa: null,
    loading_dimensions_ia: false,
    pda_ia_enable: false,
    selectedMeditionPdaIaDisabled: false,
    dashboardSuggestionsIAKey: uuid(),
  }

  componentWillUnmount = () => {
    
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {

    const { isFilter, resultDimensionsIa } = this.state
    const { plans, plans_loading } = nextProps

    if (!isEqual(nextProps, this.props)) {
      this.props.setCountTitle({
        show:
          Array.isArray(plans) &&
          (plans.length === 0 && !isFilter) === false &&
          !plans_loading,
        count: plans.length,
      })

    }

  }

  componentDidMount = () => {
    const { resultDimensionsIa } = this.state

    if(window.self !== window.top) {
      this.setState({ isIframe: true })
    }

    if (!resultDimensionsIa) {
      this.getDivisions()
    }
    this.props.getFilters()


  }

  componentDidUpdate = (nextProps) => {
    // Siempre cuando el plans_loading cambie, se reinicia el paginador
    if (nextProps.plans_loading !== this.props.plans_loading) {
      this.onChange(1)
    }

    if (nextProps.filters_loading !== this.props.filters_loading) {
      this.setState(
        {
          selectedMedition: Array.isArray(this.props.filters.measures)
            ? this.props.filters.measures.length > 0
              ? this.props.filters.measures[0].id_measure
              : null
            : null,


          pda_ia_enable: isAmbassadorActive() ? Array.isArray(this.props.filters.measures)
            ? this.props.filters.measures.length > 0
              ? this.props.filters.measures[0].hasOwnProperty('pdas_ia_enable') ? this.props.filters.measures[0].pdas_ia_enable == 1 : false
              : false
            : false : false,
          selectedMeditionPdaIaDisabled: isAmbassadorActive() ? Array.isArray(this.props.filters.measures)
            ? this.props.filters.measures.length > 0
              ? this.props.filters.measures[0].hasOwnProperty('pdas_ia_enable') ? this.props.filters.measures[0].pdas_ia_enable == 1 : false
              : false
            : false : false,
          selectedMeditionPdaIa: Array.isArray(this.props.filters.measures)
            ? this.props.filters.measures.length > 0
              ? this.props.filters.measures[0].hasOwnProperty('pdas_ia_enable') && this.props.filters.measures[0].pdas_ia_enable == 1 ? this.props.filters.measures[0].id_measure : false
              : false
            : false,

        },
        () => {
          this.props.getPlans({ measure: this.state.selectedMedition })
        }
      )
    }
  }

  onFilter = () => {
    const {
      selectedDivision,
      selectedStatus,
      selectedDimension,
      selectedMedition,
      selectedOrder,
      selectedSearch,
      selectedMeditionPdaIa,
    } = this.state

    this.setState({ isFilter: true })
    this.setState({ selectedMeditionPdaIaDisabled: selectedMedition === selectedMeditionPdaIa ? true : false });

    this.props.getPlans({
      search: selectedSearch,
      division: selectedDivision ? selectedDivision.id_division : null,
      dimension: selectedDimension || null,
      measure: selectedMedition,
      status: selectedStatus ? selectedStatus.id : null,
      order: selectedOrder ? selectedOrder.id : null,
    })
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ paginationPageSize: pageSize }, () => {
      this.onChange(1)
    })
  }

  onChange = (page) => {
    const { plans } = this.props
    const { paginationPageSize } = this.state
    this.setState({ paginationCurrentPage: page }, () => {
      const startIndex = (page - 1) * paginationPageSize
      const endIndex = Math.min(
        startIndex + paginationPageSize - 1,
        plans.length - 1
      )
      const rows = plans.slice(startIndex, endIndex + 1)
      this.setState({ rows })
    })
  }
  setStateFromTracking = (key, value) => {
    this.setState({ [key]: value })
  }
  showModalImportActionPlans = () =>
    this.setState({ isModalVisibleImportActionPlans: true })

  hideModalImportActionPlans = () =>
    this.setState({ isModalVisibleImportActionPlans: false })

  redirectImportActionPlans = (idMeasure) => {
    woopraTrack("Importar planes de accion")
    localStorage.setItem("currentMeasure", idMeasure)
    this.props.history.push(`/action-plans/import/${idMeasure}`)
  }

  renderModalImportActionPlans = () => {
    const { isModalVisibleImportActionPlans } = this.state
    const { filters } = this.props
    if (!validate.exist(filters.measures)) {
      return null
    }
    return (
      <ModalImportActionPlans
        isModalVisible={isModalVisibleImportActionPlans}
        handleCancel={() => this.hideModalImportActionPlans()}
        handleOk={(idMeasure) => this.redirectImportActionPlans(idMeasure)}
        measuresList={filters.measures}
      />
    )
  }

  getDivisions = async () => {
    try {
      const divisionsIa = await getDivisionsForAmbassadorDashboard({
        id_ambassador: LOCAL_AMBASSADOR_ID()
      });
      if (divisionsIa.status == 200) {
        const divisionsData = divisionsIa.data.data.result
        this.setState({
          loading_dimensions_ia: true,
          resultDimensionsIa: divisionsData
        })
      }

    } catch (error) {
      console.error("Error al obtener getDivisions:", error);
    }
  }

  renderEmptyStateIa = () => {
    const { resultDimensionsIa, can_create_action_plan, selectedMeditionPdaIaDisabled,dashboardSuggestionsIAKey } = this.state
    return (
      <Row className="Tracking-EmptyIa-row" >
        <Col style={{marginBottom: 220 }}>
          <div className="Tracking-EmptyIa">
            <Empty
             className="Tracking-EmptyIa"
              style={{ color: "#828282", height:0}}
              image={emptyStateActionPlans}
              description={
                <Fragment >
                  <span style={{ margin: "20px auto", display: "block" }}>
                    {sanitize(this.intl.tracking.emptyAmbassador.title)}
                  </span>

                  <span>
                    {sanitize(this.intl.tracking.emptyAmbassador.body)}
                  </span>
                  {validRole({ role: [1, 2, 3, 4, 5] }) &&
                    can_create_action_plan && <div className="Tracking-EmptyIa-button" >
                      <Button
                        className="btn-orange"
                        onClick={() => {
                          this.setState({ modalActionPlanCreate: true })
                        }}>
                        {this.intl.tracking.emptyAmbassador.button}
                      </Button></div>
                  }
                </Fragment>
              }
            />
          </div>

        </Col>
        <Col>     {resultDimensionsIa && selectedMeditionPdaIaDisabled && resultDimensionsIa.divisions && resultDimensionsIa.divisions.length > 0 && LOCAL_PDA_IA_ENABLED() && (
          <DashboardSuggestionsIA
            key={this.state.dashboardSuggestionsIAKey}
            result_dimensions_ia={resultDimensionsIa}
            dashboard={true}
            setStateFrom={this.setStateFromTracking}

            dashboardSuggestionsIAKey={dashboardSuggestionsIAKey}
            onCreatePlan={() => {
              this.props.getFilters()
              this.onFilter()

            }}
          />
        )}</Col>
      </Row>
    )
  }

  render() {
    let {
      plans_loading,
      filters,
      sidebar_divisions,
      sidebar_ambassadors,
      plans,
      total_plans,
      resume,
    } = this.props
    const {
      selectedDivision,
      selectedStatus,
      selectedMedition,
      modalActionPlanCreate,
      modalActionPlanEditId,
      selectedOrder,
      isFilter,
      paginationCurrentPage,
      rows,
      can_create_action_plan,
      modalArchivePlan,
      currentPlan,
      modalArchiveLoading,
      modalActionPlanCreateIa,
      modalActionPlanCreateNormal,
      pda_ia_enable,
      selectedMeditionPdaIaDisabled,
      resultDimensionsIa
    } = this.state
    const totalPlansAmbassadors =
      sidebar_ambassadors.reduce((a, b) => {
        return a + b.count_action_plans
      }, 0) || 0
    const totalPlansDivisions =
      sidebar_divisions.reduce((a, b) => {
        return a + b.count_action_plans
      }, 0) || 0
    const emptyPlansFirstLoad =
      Array.isArray(plans) && (plans.length === 0 && !isFilter) === false
    const isEmptyMeasures =
      (Array.isArray(filters.measures) && filters.measures.length === 0) || pda_ia_enable ? !(pda_ia_enable && filters.measures.length > 1) : false;
    const atLeastOneMeasureWithAnonimaty = resultDimensionsIa && resultDimensionsIa.measure !== null
    const validateExistDivisions = resultDimensionsIa ? (resultDimensionsIa.divisions && resultDimensionsIa.divisions.length == 0) :false


    const roles = JSON.parse(LOCAL_USER_ROLES())
    const rolesIds = roles.map((role) => role.id)

    const hasVariousRoles = (rolesIds.includes(ROLE_AMBASSADOR) || rolesIds.includes(ROLE_LEADER)) && (rolesIds.includes(ROLE_COMPANY_ADMIN) || rolesIds.includes(ROLE_COMPANY_SUPER_ADMIN))

    const isAdminLeader = rolesIds.length == 2 && (rolesIds.includes(ROLE_COMPANY_ADMIN) || rolesIds.includes(ROLE_COMPANY_SUPER_ADMIN)) && rolesIds.includes(ROLE_LEADER)
    const isOnlyAdmin = rolesIds.length == 1 && (rolesIds.includes(ROLE_COMPANY_ADMIN) || rolesIds.includes(ROLE_COMPANY_SUPER_ADMIN))

    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => {
            this.props.getTemplate(selectedMedition)
            buttonAction_btns("Exportar planes de acción")
          }}>
          <a className="ant-dropdown-link">
            <DownloadOutlined /> {this.intl.tracking.buttons.exportActionPlans}
          </a>
        </Menu.Item>
        {!isAmbassadorOrLeaderActive() && (
          <Menu.Item
            onClick={() => {
              this.props.getTemplateTask(selectedMedition)
              buttonAction_btns("Exportar tareas")
            }}>
            <a className="ant-dropdown-link">
              <DownloadOutlined /> {this.intl.tracking.buttons.exportTasks}
            </a>
          </Menu.Item>
        )}
      </Menu>
    )
    return (
      <Fragment>
        <div className="Tracking">
          <div className={`Tracking-Header-buttons 
            ${(this.state.isIframe && (hasVariousRoles)) ? "iframe" : ""} 
            ${(this.state.isIframe && !isAdminLeader && isAdmin() && !this.props.forceStuck) ? "iframe-admin" : ""}
            ${(this.state.isIframe && isOnlyAdmin) ? "topHeader" : ""}`}>
            {validRole({ role: [1, 2, 3, 4, 5] }) &&
              can_create_action_plan && (
                 (LOCAL_PDA_IA_ENABLED() && atLeastOneMeasureWithAnonimaty)
              ) && (
                <Tooltip
                  title={
                    LOCAL_AI_LIMIT_REACHED()
                      ? "Sin créditos disponibles. Por favor contacta al administrador de tu empresa."
                      : ""
                  }
                  trigger="hover"
                  overlayClassName="tooltipWhitePda">
                  <Button
                    size="large"
                    type="primary"
                    style={
                      LOCAL_AI_LIMIT_REACHED()
                        ? { marginRight: 8, background: "#e6e6e6", borderColor: "#e6e6e6", color: "#6f6f6f" }
                        : { marginRight: 8, background: "#55C8AE", borderColor: "#55C8AE" }
                    }
                    disabled={LOCAL_AI_LIMIT_REACHED()}
                    onClick={() => {
                      this.setState({ modalActionPlanCreate: true, modalActionPlanCreateIa: true })
                    }}>
                    <span style={{ marginLeft: -3, marginTop: 2, display: "inline-flex" }}>
                      <IconoVaritaMagica fill={LOCAL_AI_LIMIT_REACHED() ? "#6f6f6f" : "#FFFFFF"} />
                    </span>
                    <span style={{ marginLeft: 7,marginBottom: 4 }}>{this.intl.tracking.buttons.createActionPlanIa}</span>

                  </Button>
                </Tooltip>
              )}
             {validRole({ role: [1, 2, 3, 4, 5] }) &&
              can_create_action_plan && (
                (LOCAL_PDA_IA_ENABLED() && atLeastOneMeasureWithAnonimaty) ||
                (!LOCAL_PDA_IA_ENABLED() && emptyPlansFirstLoad && !isEmptyMeasures)
              ) && (
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  woopraTrack("Crear plan de acción")
                  this.setState({ modalActionPlanCreate: true, modalActionPlanCreateNormal: true })
                }}>

                {this.intl.tracking.buttons.createActionPlan}
              </Button>
            )}
            {validRole({ role: [1, 2, 3, 4] }) &&
              can_create_action_plan &&
              emptyPlansFirstLoad &&
              !isEmptyMeasures && (
                <Tooltip
                  title="Importar planes de acción"
                  placement="bottomRight"
                  onClick={() => this.showModalImportActionPlans()}
                  align={{
                    offset: [4, 4],
                  }}>
                  <Button
                     size="large"
                    className="whiteButton"
                    style={{ marginLeft: 8 }}
                    icon={<UploadOutlined />}
                  />
                </Tooltip>
              )}
            {!plans_loading && emptyPlansFirstLoad && total_plans > 0 && (
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button
                 size="large"
                  className="whiteButton"
                  style={{ marginLeft: 8 }}
                  icon={<DownloadOutlined />}
                />
              </Dropdown>
            )}
          </div>
          {plans_loading && !isFilter ? (
            <div className="loadingSpin" style={{ height: (window.self !== window.top) ? "90vh" : "auto" }}>
              <Spin size="large" />
            </div>
          ) : // Se añade la validación de validateIfExistMeasures para cuando que al archivar todos
            // los planes de acción, se muestra el empty state.
            isEmptyMeasures && !plans_loading ? (LOCAL_PDA_IA_ENABLED() && !pda_ia_enable || validateExistDivisions  ? (

              <div className="Tracking-Empty">
                <Empty
                  style={{ color: "#828282"  }}
                  image={emptyStateActionPlans}
                  description={
                    <Fragment>
                      <span style={{ margin: "20px auto", display: "block", top : -173, position: "relative",fontSize:16 }}>
                        {sanitize(this.intl.tracking.empty.title)}
                      </span>
                      {validRole({ role: [1, 2, 3, 4, 5] }) &&
                        can_create_action_plan && (
                          <Button
                            className="btn-orange"
                            onClick={() => {
                              woopraTrack("Crear plan de acción")
                              this.setState({ modalActionPlanCreate: true })
                            }}>
                            {this.intl.tracking.empty.button}
                          </Button>
                        )}
                      <span className="Tracking-Empty-dashed">
                        {sanitize(this.intl.tracking.empty.body)}
                      </span>

                    </Fragment>
                  }
                />
              </div>
            ) :  this.renderEmptyStateIa()) : (
              <Fragment>
                <div className="Tracking-Filters">
                  <AutoComplete
                    disabled={selectedMeditionPdaIaDisabled}
                    allowClear
                    url="action-plans/search-filter/?search="
                    placeholder={this.intl.tracking.placeholders.search}
                    onSelect={(e) => {
                      this.setState({ selectedSearch: e }, () => this.onFilter())
                    }}
                  />
                  <SelectHR
                    value={selectedMedition}
                    options={filters.measures}
                    placeholder={this.intl.tracking.placeholders.selectMeasure}
                    style={{ width: "100%" }}
                    label="name"
                    labelKey="id_measure"
                    onChange={(selectedMedition) => {
                      this.setState(
                        {
                          selectedMedition: !selectedMedition
                            ? null
                            : selectedMedition.id_measure,
                        },
                        () => this.onFilter()
                      )
                    }}
                  />
                  <SelectHR
                    disabled={selectedMeditionPdaIaDisabled}
                    allowClear
                    value={selectedStatus}
                    options={filters.status}
                    placeholder={this.intl.tracking.placeholders.selectStatus}
                    style={{ width: "100%" }}
                    label="name"
                    labelKey="id"
                    onChange={(selectedStatus) => {
                      this.setState({ selectedStatus }, () => this.onFilter())
                    }}
                  />
                  <TreeSelect
                    disabled={selectedMeditionPdaIaDisabled}
                    placeholder={this.intl.tracking.placeholders.selectDimensions}
                    style={{ width: "100%" }}
                    dropdownStyle={{ maxHeight: 250 }}
                    showSearch
                    allowClear
                    treeDefaultExpandAll
                    treeNodeFilterProp="title"
                    onChange={(s, c, extra) => {
                      this.setState({ selectedDimension: s }, () => {
                        this.onFilter()
                      })
                    }}>
                    {filters.dimensions &&
                      filters.dimensions.map((e) => {
                        return (
                          <TreeNode

                            idSelected={e.id_dimension}
                            value={e.id_dimension}
                            title={e.name}
                            key={e.id_dimension}>
                            {e.childs &&
                              e.childs.map((child) => {
                                return (
                                  <TreeNode
                                    value={child.id_dimension}
                                    title={child.name}
                                    key={child.id_dimension}
                                    idSelected={child.id_dimension}
                                  />
                                )
                              })}
                          </TreeNode>
                        )
                      })}
                  </TreeSelect>

                  <SelectHR
                    disabled={selectedMeditionPdaIaDisabled}
                    allowClear
                    value={selectedDivision}
                    options={filters.division}
                    placeholder={this.intl.tracking.placeholders.selectDivision}
                    style={{ width: "100%" }}
                    label="name"
                    labelKey="id_division"
                    onChange={(selectedDivision) => {
                      this.setState({ selectedDivision }, () => this.onFilter())
                    }}
                  />
                </div>
                {!selectedMeditionPdaIaDisabled ?
                  <div className="Tracking-Blocks"style={{ ...(typeof window.Intercom !== "undefined" &&
                    window.self === window.top && {
                    marginBottom: "99px"}) }} >
                    <div className="Tracking-Blocks-left">
                      {selectedDivision && (
                        <div style={{ marginBottom: 15 }}>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "18px auto",
                              gridGap: "7px",
                            }}>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.setState({ selectedDivision: null }, () =>
                                  this.onFilter()
                                )
                              }}>
                              <img src={arrowLeftBlue} alt="arrow-left-blue" />
                            </span>
                            <div style={{ fontSize: 16 }}>
                              <b>{selectedDivision.name}</b>
                            </div>
                          </div>
                        </div>
                      )}

                      <div style={{ marginBottom: 15 }}>
                        <b className="color-gray-low">
                          {this.intl.tracking.labels.sortBy}{" "}
                        </b>
                        <SelectHR
                          wrapperStyle={{ display: "inline-table" }}
                          style={{ marginLeft: 10, width: 200 }}
                          value={
                            selectedOrder
                              ? selectedOrder.id
                              : Array.isArray(filters.order)
                                ? filters.order[0].id
                                : null
                          }
                          options={filters.order}
                          placeholder="Seleccionar"
                          label="name"
                          labelKey="id"
                          onChange={(selectedOrder) => {
                            this.setState({ selectedOrder }, () => this.onFilter())
                          }}
                        />
                      </div>
                      <div style={{ display: "grid", gridGap: 7 }}>
                        {plans_loading && isFilter ? (
                          <div className="loadingSpin">
                            <Spin size="large" />
                          </div>
                        ) : Array.isArray(rows) && rows.length > 0 ? (
                          <Fragment>
                            {rows.map((p, pi) => {
                              return (
                                <ActionPlanCard
                                  canCreateTask
                                  canOpen
                                  canEdit={p.editable}
                                  item={p}
                                  key={`action-plan-${p.id_action_plan}`}
                                  onEdit={(e) => {
                                    this.setState({
                                      modalActionPlanCreate: true,
                                      modalActionPlanEditId: p.id_action_plan,
                                    })
                                  }}
                                  onArchive={(e) => {
                                    this.setState({
                                      modalArchivePlan: true,
                                      currentPlan: p,
                                    })
                                  }}
                                  index={pi} 
                                  onReloadActionPlan={(e) => {
                                    rows[pi] = Object.assign(rows[pi], e)
                                    this.setState({ rows })
                                  }}
                                />
                              )
                            })}
                            {!plans_loading && (
                              <Pagination
                                showSizeChanger
                                defaultPageSize={15}
                                pageSizeOptions={["15", "25", "50", "100"]}
                                onShowSizeChange={this.onShowSizeChange}
                                onChange={this.onChange}
                                defaultCurrent={paginationCurrentPage}
                                total={plans.length}
                              />
                            )}
                          </Fragment>
                        ) : (
                          <Empty
                            style={{ color: "#828282", marginTop: 60 }}
                            image={emptyStateActionPlans}
                            description={
                              <span
                                style={{ margin: "20px auto", display: "block" }}>
                                  {this.intl.tracking.empty.filters}
                              </span>
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div className="Tracking-Blocks-right">
                      {!plans_loading && (
                        <div className="Tracking-Blocks-right-box">
                          <WidgetResumeActionPlans data={resume} />
                        </div>
                      )}

                      <div
                        className="Tracking-Blocks-right-box"
                        style={{ display: selectedDivision ? "none" : null }}>
                        <List
                          size="small"
                          loading={plans_loading}
                          header={
                            <div className="Tracking-Blocks-right-box-header">
                              <div>
                                {this.intl.tracking.labels.divisions}{" "}
                                <span>
                                  <Sorter
                                    data={sidebar_divisions}
                                    byKey="count_action_plans"
                                    onChange={(items) => {
                                      sidebar_divisions = items
                                      this.forceUpdate()
                                    }}
                                  />
                                </span>
                              </div>
                              <span className="Tracking-Blocks-right-box-header-right">
                                {totalPlansDivisions}{" "}
                                {plural(
                                  "plan",
                                  totalPlansDivisions,
                                  getLanguage() == "es" ? "es" : "s"
                                )}
                              </span>
                            </div>
                          }
                          bordered
                          dataSource={
                            Array.isArray(sidebar_divisions)
                              ? sidebar_divisions
                              : []
                          }
                          renderItem={(item) => {
                            return (
                              <List.Item key={item.id_division}>
                                <List.Item.Meta
                                  title={
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        this.setState(
                                          { selectedDivision: item },
                                          () => {
                                            this.onFilter()
                                          }
                                        )
                                      }}>
                                      {item.name}
                                    </div>
                                  }
                                />
                                <div style={{ paddingTop: 1 }}>
                                  {item.count_action_plans}{" "}
                                  {plural(
                                    "plan",
                                    item.count_action_plans,
                                    getLanguage() == "es" ? "es" : "s"
                                  )}
                                </div>
                              </List.Item>
                            )
                          }}
                        />
                      </div>
                      <div className="Tracking-Blocks-right-box">
                        <List
                          size="small"
                          loading={plans_loading}
                          header={
                            <div className="Tracking-Blocks-right-box-header">
                              <div>
                                {this.intl.tracking.labels.ambassadors}{" "}
                                <span>
                                  <Sorter
                                    data={sidebar_ambassadors}
                                    byKey="count_action_plans"
                                    onChange={(items) => {
                                      sidebar_ambassadors = items
                                      this.forceUpdate()
                                    }}
                                  />
                                </span>
                              </div>
                              <span className="Tracking-Blocks-right-box-header-right">
                                {totalPlansAmbassadors}{" "}
                                {plural(
                                  "plan",
                                  totalPlansAmbassadors,
                                  getLanguage() == "es" ? "es" : "s"
                                )}
                              </span>
                            </div>
                          }
                          bordered
                          dataSource={
                            Array.isArray(sidebar_ambassadors)
                              ? sidebar_ambassadors
                              : []
                          }
                          renderItem={(item) => {
                            return (
                              <List.Item key={item.id_ambassador}>
                                <List.Item.Meta
                                  avatar={<Avatar src={item.profile_picture} />}
                                  title={<div>{item.full_name}</div>}
                                />
                                <div style={{ paddingTop: 1 }}>
                                  {item.count_action_plans}{" "}
                                  {plural(
                                    "plan",
                                    item.count_action_plans,
                                    getLanguage() == "es" ? "es" : "s"
                                  )}
                                </div>
                              </List.Item>
                            )
                          }}
                        />
                      </div>
                    </div>
                  </div> : this.renderEmptyStateIa()}
              </Fragment>
            )}
        </div>
        <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          setStateFromTracking={this.setStateFromTracking}
          modalActionPlanEditId={modalActionPlanEditId}
          modalActionPlanCreateIa={modalActionPlanCreateIa}
          modalActionPlanCreateNormal={modalActionPlanCreateNormal}
          onCancel={() =>
            this.setState({
              modalActionPlanCreate: false,
              modalActionPlanEditId: null,
              modalActionPlanCreateIa: false,
              modalActionPlanCreateNormal: false,
            })
          }
          canCreate={(value) => {
            this.setState({ can_create_action_plan: value })
          }}
          finish={() => {
            this.props.getFilters()
            this.onFilter()
            this.setState({ modalActionPlanEditId: null })
          }}
        />
        <ModalCustom
          modalOpen={modalArchivePlan}
          showFooter
          textButton={this.intl.tracking.archiveModal.archive}
          onOk={async () => {
            this.setState({ modalArchiveLoading: true })
            try {
              
              const result = await saveActionPlanApi({
                id: currentPlan.id_action_plan,
                archived: 1,
              })
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
                currentPlan: {},
              })
              this.props.getFilters()

              this.onFilter()
              this.getDivisions()
              returnMessage(result)
            } catch (error) {
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
              })
              returnMessage(error)
            }
          }}
          onCancel={() => {
            this.setState({ modalArchivePlan: false })
          }}
          isLoadingButton={modalArchiveLoading}>
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" alt="alert-svg" />
            <div className="component-deletesimple__description">
              <p>
                <b>{this.intl.tracking.archiveModal.title}</b>
              </p>
              <p>{this.intl.tracking.archiveModal.body}</p>
            </div>
          </div>
        </ModalCustom>
        {this.renderModalImportActionPlans()}
      </Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  filters_loading: makeSelectIsLoadingFilters(),
  filters: makeSelectFilters() ,
  plans_loading: makeSelectLoadingPlans(),
  plans: makeSelectPlans(),
  sidebar_ambassadors: makeSelectSidebarAmbassadors(),
  sidebar_divisions: makeSelectSidebarDivisions(),
  total_plans: makeSelectCountActionPlansDivisions(),
  resume: makeSelectResume(),
})

function mapDispatchToProps(dispatch) {
  return {
    getFilters: (params) => dispatch(filtersWatcher(params)),
    getPlans: (params) => dispatch(getPlansWatcher(params)),
    getTemplate: (params) => dispatch(getTemplate(params)),
    getTemplateTask: (params) => dispatch(getTemplateTask(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "Tracking", reducer })
const withSaga = injectSaga({ key: "Tracking", saga })

export default compose(withReducer, withSaga, withConnect)(Tracking)
